import { BasicPage } from "../components/BasicPage";
import Settings from "@mui/icons-material/Settings";

export const SettingsPage = () => {
  return <BasicPage title="Settings Page" icon={<Settings />} />;
};
